import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import loadingSpinner from './assets/loading.gif';
import { Routes, Route, Navigate } from "react-router-dom";
// import { isBenby } from "./components/Security";
import { clearClientCloudConfig, DEV_MODE } from './components/Security';
import Sidebar from './components/Menu/Sidebar';
import Topbar from './components/Menu/Topbar';
import Home from './components/HomeFld/Home';
import TimeKeeping from './components/TimeKeeping/TimeEntriesFld/TimeKeeping';
import UploadTimeEntriesFile from './components/TimeKeeping/UploadTimeEntriesFileFld/UploadTimeEntriesFile';
import UploadTimeEntriesERE from './components/TimeKeeping/UploadTimeEntriesERE/UploadTimeEntriesERE';
import TamperedApproval from './components/TimeKeeping/TamperedApproval';
import PartialSalary from './components/Payroll/PartialSalaryFld/PartialSalary';
import Payroll from './components/Payroll/Payroll';
import ThirteenthMonth from './components/Payroll/ThirteenthMonth';
import FinalPay from './components/Payroll/FinalPay';
import Subcon from './components/Payroll/Subcon';
import Agency from './components/Payroll/Agency';
import PayType from './components/Maintenance/PayType';
import Holiday from './components/Maintenance/Holiday';
import HolidayType from './components/Maintenance/HolidayType';
// import Tax from './components/GovernmentPremiums/Tax';
import Tax from './components/GovernmentPremiums/TaxNew';
import Pagibig from './components/GovernmentPremiums/Pagibig';
import SSS from './components/GovernmentPremiums/SSS';
// import Philhealth from './components/GovernmentPremiums/Philhealth';
import Philhealth from './components/GovernmentPremiums/PhilhealthNew';
import Ecola from './components/Maintenance/Ecola';
import Section from './components/Maintenance/Section';
import Classification from './components/Maintenance/Classification';
import Client from './components/Maintenance/Client';
import PayrollPeriod from './components/Payroll/PayrollPeriod';
import SSSAdjustmentDate from './components/Maintenance/SSSAdjustmentDate';
import Company from './components/Maintenance/Company';
import DTRCorrectionWorkers from './components/Transaction/DTRCorrectionWorkers';
import DTRAdminView from './components/Transaction/DTRAdminView';
import DTREmployeeView from './components/Transaction/DTREmployeeView';
import MobileDTRApproval from './components/Transaction/MobileDTRApproval';
import ApproverHierarchy from './components/Transaction/ApproverHierarchy/ApproverHierarchy';
import ApproverHierarchyPerLocation from './components/Transaction/ApproverHierarchyPerLocation';
import RequestApproval from './components/Transaction/RequestApprovalFld/RequestApproval';
import RequestApprovalTimeKeeper from './components/Transaction/RequestApprovalTimeKeeper';
import MassApproval from './components/Transaction/MassApproval';
import Overtime from './components/Transaction/Overtime';
import DTRCorrection from './components/Transaction/DTRCorrection';
// import Leave from './components/Transaction/Leave';
import ChangeOfSchedule from './components/Transaction/ChangeOfSchedule';
import LeaveTypes from './components/Maintenance/LeaveTypes';
import Benefits from './components/LoansBenefits/Benefits';
import Loans from './components/LoansBenefits/Loans';
import AddEmployee from './components/Personnel/AddEmployee';
import EmployeeInformation from './components/Personnel/EmployeeInformation';
import EmployeesList from './components/Personnel/EmployeesList';
import EmployementStatus from './components/Personnel/EmployementStatus';
import OnBoarding from './components/Personnel/OnBoarding';
import OutBoarding from './components/Personnel/OutBoarding';
import OnBoardingPersonnel from './components/Personnel/OnBoardingPersonnel';
import CrewList from './components/Personnel/CrewListFld/CrewList';
import EmployeeRequest from './components/Personnel/EmployeeRequestFld/EmployeeRequest';
import TrainingAndSeminarProgram from './components/TalentManagement/TrainingAndSeminarFld/TrainingAndSeminarProgram';
import KpiPerformanceAppraisal from './components/TalentManagement/KpiPerformanceAppraisalFld/KpiPerformanceAppraisal';
import EmployeeMonthlySalary from './components/SalaryModule/EmployeeMonthlySalary';
import EmployeeDailySalary from './components/SalaryModule/EmployeeDailySalary';
import QuotaBasedSalary from './components/SalaryModule/QuotaBasedSalary';
import PositionDesignationSalary from './components/SalaryModule/PositionDesignationSalary';
import EmployeeSchedule from './components/Personnel/EmployeeSchedule';
import EmployeeReliever from './components/Personnel/EmployeeReliever';
import EmployeeBankAccount from './components/SalaryModule/EmployeeBankAccount';
import JobTitle from './components/Maintenance/JobTitle';
import EmployeeGroup1 from './components/Maintenance/EmployeeGroup1';
import EmployeeGroup2 from './components/Maintenance/EmployeeGroup2';
import EmployeeStatus from './components/Maintenance/EmployeeStatus';
import Location from './components/Maintenance/Location';
import TimeKeeper from './components/Maintenance/TimeKeeper';
import Plantilya from './components/Maintenance/Plantilya';
import CostCenter from './components/Maintenance/CostCenter';
import PayrollJournalAccount from './components/Maintenance/PayrollJournalAccount';
import Requirements from './components/Maintenance/Requirements';
import OutBoardingRequirements from './components/Maintenance/OutBoardingRequirements';
import MRF from './components/TalentManagement/MrfFld/MRF';
import Vessel from './components/Maintenance/Vessel';
import KpiLegend from './components/Maintenance/KpiLegendFld/KpiLegend';
import Destination from './components/Maintenance/Destination';
import Division from './components/Maintenance/Division';
import VesselStatus from './components/Maintenance/VesselStatus';
import VesselType from './components/Maintenance/VesselType';
import EmployeeType from './components/Maintenance/_____EmployeeType.js';
import MemoType from './components/Maintenance/MemoType';
import LoansAccess from './components/Maintenance/LoansAccess';
import MRFAccess from './components/Maintenance/MRFAccess';
import EmployeeRequestAccess from './components/Maintenance/EmployeeRequestAccess';
// import Announcement from './components/Maintenance/Announcement';
import ShiftSchedule from './components/TimeKeeping/ShiftSchedule';
import Payslip from './components/Reports/Payslip';
import PayrollRegister from './components/Reports/PayrollRegister';
// import PayrollHistory from './components/Reports/PayrollHistory';
import Resigned from './components/Reports/Resigned';
import ActiveEmployees from './components/Reports/ActiveEmployees';
import YearOfService from './components/Reports/YearOfService';
import SSSReport from './components/Reports/SSSReport';
import PagibigReport from './components/Reports/PagibigReport';
import PhilhealthReport from './components/Reports/PhilhealthReport';
import SSSLoanReport from './components/Reports/SSSLoanReport';
import PagibigLoanReport from './components/Reports/PagibigLoanReport';
import Report201 from './components/Reports/Report201';
import Users from './components/UserFld/Users';
import SSSLoan from './components/LoansBenefits/SSSLoan';
import Settings from './components/Settings';
import Calendar from './components/CalendarFld/Calendar';
import LoginForm from './components/LoginForm';
import SSSCalamityLoan from './components/LoansBenefits/SSSCalamityLoan';
import PagibigLoan from './components/LoansBenefits/PagibigLoan';
import PagibigCalamityLoan from './components/LoansBenefits/PagibigCalamityLoan';
import CashAdvance from './components/LoansBenefits/CashAdvance';
import Deductions from './components/LoansBenefits/Deductions';
import AttendanceReport from './components/Reports/AttendanceReport';
import BankTransmittalBPI from './components/Reports/BankTransmittalBPI';
import BankTransmittalBDO from './components/Reports/BankTransmittalBDO';
import BankTransmittalChinaBank from './components/Reports/BankTransmittalChinaBank';
import BankTransmittalHSBC from './components/Reports/BankTransmittalHSBC';
import BankTransmittalSecurityBank from './components/Reports/BankTransmittalSecurityBank';
import SummaryOfTardiness from './components/Reports/SummaryOfTardiness';
import AbsencesMemo from './components/Reports/AbsencesMemo';
import AbsencesReport from './components/Reports/AbsencesReport';
import ActionHistoryReport from './components/Reports/ActionHistoryReport';
import AllowanceSummary from './components/Reports/AllowanceSummary';
import AuditTrailReportEmployeeSetup from './components/Reports/AuditTrailReportEmployeeSetup';
import BundyClockUsage from './components/Reports/BundyClockUsage';
import BasicPayAdjustmentReport from './components/Reports/BasicPayAdjustmentReport';
import CertificateOfEmployment from './components/Reports/CertificateOfEmployment';
import CertificateOfPagibig from './components/Reports/CertificateOfPagibig';
import CertificateOfPhilhealth from './components/Reports/CertificateOfPhilhealth';
import CertificateOfSSS from './components/Reports/CertificateOfSSS';
import CommissionsSummary from './components/Reports/CommissionsSummary';
import CostCenterReport from './components/Reports/CostCenterReport';
import DeductionsPerMonth from './components/Reports/DeductionsPerMonth';
import DTRReport from './components/Reports/DTRReport';
import EarningsPerMonth from './components/Reports/EarningsPerMonth';
import EmployeeLeaveGroup from './components/Reports/EmployeeLeaveGroup';
import EmployeeOvertimeGroup from './components/Reports/EmployeeOvertimeGroup';
import EmployeeExpenseGroup from './components/Reports/EmployeeExpenseGroup';
import EmployeeLeaveHistory from './components/Reports/EmployeeLeaveHistory';
import EmployeeListingByHiringDate from './components/Reports/EmployeeListingByHiringDate';
import EmployeeRegister from './components/Reports/EmployeeRegister';
import ExpenseReport from './components/Reports/ExpenseReport';
import PerDayTracker from './components/Reports/PerDayTracker';
import OvertimeSummaryReport from './components/Reports/OvertimeSummaryReport';
import TrackerReport from './components/Reports/TrackerReport';
import GovernmentEmployeeInventory from './components/Reports/GovernmentEmployeeInventory';
import HeadcountReport from './components/Reports/HeadcountReport';
import HolidayPremiumSummary from './components/Reports/HolidayPremiumSummary';
import LeaveLedgerReport from './components/Reports/LeaveLedgerReport';
import LeaveSummaryReport from './components/Reports/LeaveSummaryReport';
import LoanHistory from './components/Reports/LoanHistory';
import LoanPaymentsSummary from './components/Reports/LoanPaymentsSummary';
import LoansMonthlyAmmortizationSummary from './components/Reports/LoansMonthlyAmmortizationSummary';
import LoansPenaltyHistory from './components/Reports/LoansPenaltyHistory';
import NightDifferentialSummary from './components/Reports/NightDifferentialSummary';
import NonTaxableAllowancesReport from './components/Reports/NonTaxableAllowancesReport';
import OtherEarningsReport from './components/Reports/OtherEarningsReport';
import OtherDeductionsSummary from './components/Reports/OtherDeductionsSummary';
import OutstandingLoans from './components/Reports/OutstandingLoans';
import PayrollCashRegister from './components/Reports/PayrollCashRegister';
import PayrollCheckRegister from './components/Reports/PayrollCheckRegister';
import PayrollDebitMemo from './components/Reports/PayrollDebitMemo';
import PayrollJournalByCostCenter from './components/Reports/PayrollJournalByCostCenter';
import PayrollJournalByDepartment from './components/Reports/PayrollJournalByDepartment';
import PayrollJournalBySummary from './components/Reports/PayrollJournalBySummary';
import PayrollPerPaymentMethod from './components/Reports/PayrollPerPaymentMethod';
import SelectLogs from './components/Reports/SelectLogs';
import SummaryReportByMonthAndDepartment from './components/Reports/SummaryReportByMonthAndDepartment';
import TardinessMemo from './components/Reports/TardinessMemo';
import TimeKeepingHistoryDetailedReport from './components/Reports/TimeKeepingHistoryDetailedReport';
import TimeKeepingHoursWorkedReport from './components/Reports/TimeKeepingHoursWorkedReport';
import TimeKeepingHoursWorkedSummary from './components/Reports/TimeKeepingHoursWorkedSummary';
import TimesheetStatusReport from './components/Reports/TimesheetStatusReport';
import YTDDeductionSummary from './components/Reports/YTDDeductionSummary';
import YTDEarningsSummary from './components/Reports/YTDEarningsSummary';
import YTDPayrollRegister from './components/Reports/YTDPayrollRegister';
import BIR2316 from './components/Reports/BIR2316';
import BIR1601C from './components/Reports/BIR1601C';
import Alphalist from './components/Reports/Alphalist';
import LoanReport from './components/Reports/LoanReport';
import BankTransmittalReport from './components/Reports/BankTransmittalReport';
import SubscriptionExpiredPage from './SubscriptionExpiredPage';
import OffsetCredits from './components/Transaction/OffsetCredits';
import OffsetRequest from './components/Transaction/OffsetRequest';
// import { useCheckMatchUrl } from './hooks/useUrlCheck';
import { RefetchProvider } from './hooks/useRefetchTrigger';
import { clearClientIdentity } from './config/client';

//DEV MODE
import DTRRulesConfiguration from './components/DevMode/DTRRulesConfiguration';
import OTFormulas from './components/DevMode/OTFormulas';
import MonthlyWorkingDaysFormulas from './components/DevMode/MonthlyWorkingDaysFormulas';
import NightDifferential from './components/DevMode/NightDifferential';
import GovPremiumFormulas from './components/DevMode/GovPremiumFormulas';
import ClientIdentity from './components/DevMode/ClientIdentity';
import GracePeriodFormulas from './components/DevMode/GracePeriodFormulas';
import PayrollRateConfig from './components/DevMode/PayrollRateConfig';
import ExcelUploadHelper from './components/DevMode/ExcelUploadHelper';

// Test Mode
import DevTest from './components/DevMode/DevTest';
import DevHobby from './components/DevMode/DevHobby';
import EmployeeHeirarchy from './components/Personnel/EmployeeHeirarchyFld/EmployeeHeirarchy';


import { AccessRequired } from './common/AccessRequired';


import Vessel201 from './components/VesselModule/Vessel201';
import DistantWater from './components/Maintenance/DistantWater';
import AreaOfOperation from './components/Maintenance/AreaOfOperations';
import SubArea from './components/Maintenance/SubArea';
import VesselFunction from './components/Maintenance/VesselFunction';
import VesselClass from './components/Maintenance/VesselClass';
import OperationGroup from './components/Maintenance/OperationGroup';
import PartialSalaryBatch from './components/Payroll/PartialSalaryBatchFld/PartialSalaryBatch';
import ProcessPartialSalary from './components/Payroll/ProcessPartialSalaryFld/ProcessPartialSalary';
import PartialSalarySchedule from './components/Maintenance/PartialSalarySchedule';
import SalaryAdvanceRequest from './components/Transaction/SalaryAdvanceRequestFld/SalaryAdvanceRequest'; // update this
import SalaryAdvance from './components/LoansBenefits/SalaryAdvanceFld/SalaryAdvance';
import { FEATURES } from './config/features';
import LeaveEncashmentPage from './v2/pages/Transactions/LeaveEncashmentPage';
import HRCalendarPage from './v2/pages/Maintenance/HRCalendarPage';
import LeaveTypePageDev from './components/DevMode/LeaveTypeDev';
import EmployeeTypeTagging from './v2/pages/Personnel/EmployeeTypeTagging';
import BIR0619E from './v2/pages/Reports/BIR0619E';
import BIR0619F from './v2/pages/Reports/BIR0619F';
import ReportR1A from './v2/pages/Reports/ReportR1A';
import ReportR3 from './v2/pages/Reports/ReportR3';
import ReportR5 from './v2/pages/Reports/ReportR5';
import ReportML1 from './v2/pages/Reports/ReportML1';
import EmployeeContributionHistory from './v2/pages/Reports/EmployeeContributionHistory';
import SalaryLoanDeductionReport from './v2/pages/Reports/SalaryLoanDeductionReport';
import ReportSSSCalamityLoan from './v2/pages/Reports/ReportSSSCalamityLoan';
import ReportMCRF from './v2/pages/Reports/ReportMCRF';
import ReportSTL from './v2/pages/Reports/ReportSTL';
import ReportHousingLoan from './v2/pages/Reports/ReportHousingLoan';
import ReportRF1 from './v2/pages/Reports/ReportRF1';
import ReportER2 from './v2/pages/Reports/ReportER2';
import EmployeeContributionLedger from './v2/pages/Reports/EmployeeContributionLedger';
import SeparatedEmployeeReport from './v2/pages/Reports/SeparatedEmployeeReport';
import UploadingSchedulePage from './v2/pages/Personnel/UploadingSchedulePage';
import ClinicRequirementsPage from './v2/pages/Maintenance/ClinicRequirementsPage';
import MedicalClearancePage from './v2/pages/Personnel/MedicalClearancePage';
import MedicalClearanceAccessPage from './v2/pages/Maintenance/MedicalClearanceAccessPage';
import EmployeeTransactionPage from './v2/pages/Personnel/EmployeeTransactionPage';
import EmployeeTransactionAccessPage from './v2/pages/Maintenance/EmployeeTransactionAccessPage';
import SalaryAdvanceAccessPage from './v2/pages/Maintenance/SalaryAdvanceAccessPage';
import SSSEmergencyLoan from './components/LoansBenefits/SSSEmergencyLoan';
import SalaryAdvanceDeductionBracketPage from './v2/pages/Maintenance/SalaryAdvanceDeductionBracket';
import LoanTransactionPage from './v2/pages/LoansBenefits/LoanTransactionPage';
import { Maintenance } from './common/Maintenance';
import PayrollReasonCodePage from './v2/pages/Maintenance/PayrollReasonCodePage';
import MaintenanceSalaryCombinationV2Page from './v2/pages/SalaryModule/MaintenanceSalaryCombinationV2Page';
import UploadDaysEntriesPage from './v2/pages/TimeEntries/UploadDaysEntriesPage';
import ApproverMaintenancePage from './v2/pages/Transactions/ApproverMaintenancePage';
import PositionPage from './v2/pages/Maintenance/PositionPage';
import DepartmentPage from './v2/pages/Maintenance/DepartmentPage';
import UploadCvtLogsPage from './v2/pages/TimeEntries/UploadCvtLogsPage';
import DTRWithOTViewingPage from './v2/pages/Transactions/DTRWithOTViewingPage';
import TransactionAccessPage from './v2/pages/Maintenance/TransactionAccessPage';
import LeaveIncentivePage from './v2/pages/Transactions/LeaveIncentivePage';
import MaintenanceSalaryCombinationCodePage from './v2/pages/Maintenance/MaintenanceSalaryCombinationCodePage';
import EmployeeTypePage from './v2/pages/Maintenance/EmployeeTypePage.js';
import Leave from './v2/pages/Transactions/LeavePage.js';


// import WebSocketComponent from './components/WebSocket';

function App() {
  const subcribed = true;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState([]);
  const [userAccess, setUserAccess] = useState([]);
  const [employeePhoto, setEmployeePhoto] = useState(null);

  const [isHideSideMenu, setIsHideSideMenu] = useState(false);

  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpiration');

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn');
    if (loggedIn === 'true') {
      setIsLoggedIn(true);
    }
    setIsLoading(false);


    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(storedUser);
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing userAccess:', error);
        setUser([]);
      }
    }

    const storedUserAccess = localStorage.getItem('userAccess');
    if (storedUserAccess) {
      try {
        setUserAccess(JSON.parse(storedUserAccess));
      } catch (error) {
        console.error('Error parsing userAccess:', error);
        setUserAccess([]);
      }
    }
  }, []);

  const handleLogin = (user, userAccess) => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', true);

    setUser(user);
    localStorage.setItem('user', JSON.stringify(user));

    setUserAccess(userAccess)
    localStorage.setItem('userAccess', JSON.stringify(userAccess));
  };

  const handleLogout = useCallback(async () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');

    localStorage.removeItem('user');
    localStorage.removeItem('userAccess');
    setUser([]);
    setUserAccess([]);

    clearClientCloudConfig();
    clearClientIdentity();

    window.location.pathname = "/";
  }, []);

  useEffect(() => {
    if (!isLoggedIn) return;

    let idleTimer;

    const handleUserIdle = () => {
      handleLogout();
    };

    const resetIdleTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(handleUserIdle, userAccess?.userTimeOut ? userAccess?.userTimeOut * 60000 : 2 * 60000);
    };

    window.addEventListener('mousemove', resetIdleTimer);
    window.addEventListener('keypress', resetIdleTimer);
    window.addEventListener('touchstart', resetIdleTimer);

    resetIdleTimer();

    return () => {
      window.removeEventListener('mousemove', resetIdleTimer);
      window.removeEventListener('keypress', resetIdleTimer);
      window.removeEventListener('touchstart', resetIdleTimer);
      clearTimeout(idleTimer);
    };
  }, [handleLogout, isLoggedIn, userAccess]);

  // Handle the access per user (Create, Read, Edit, Delete)
  // Hide the buttons the that user don't have access
  // useCheckMatchUrl(userAccess);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
        <img src={loadingSpinner} alt="Loading..." />
      </div>
    )
  }

  const isDevMode = process.env.REACT_APP_DEV_MODE === 'true';

  return (
    <>
      {/* <WebSocketComponent /> */}
      <RefetchProvider>
        <div className="App">
          {subcribed ?
            <>
              {!isLoggedIn ? (
                <>
                  {/* {resetDomainRootId()} */}
                  <LoginForm handleLogin={handleLogin} />
                </>
              ) : (
                <>
                  <div className="sidebar-content">
                    <Sidebar user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} setIsHideSideMenu={setIsHideSideMenu} />
                  </div>
                  <div className="topbar-content">
                    <Topbar handleLogout={handleLogout}
                      user={user}
                      userAccess={userAccess}
                      employeePhoto={employeePhoto} setEmployeePhoto={setEmployeePhoto}
                      isHideSideMenu={isHideSideMenu}
                    />
                  </div>
                  <div className="content">
                    <Routes>
                      <Route path="/" element={<Home user={user} userAccess={userAccess} employeePhoto={employeePhoto} setEmployeePhoto={setEmployeePhoto} isHideSideMenu={isHideSideMenu} />} />
                      {userAccess?.hasAddEmployee ?
                        (
                          <Route path="/addEmployee" element={<AddEmployee user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.description === "Employee" ?
                        (
                          <Route path="/employeeInformation" element={<EmployeeInformation user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeList ?
                        (
                          <Route path="/employeesList" element={<EmployeesList user={user} userAccess={userAccess} employeePhoto={employeePhoto} setEmployeePhoto={setEmployeePhoto} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeHeirarchy ?
                        (
                          <Route path="/employeeHeirarchy" element={<EmployeeHeirarchy user={user} userAccess={userAccess} employeePhoto={employeePhoto} setEmployeePhoto={setEmployeePhoto} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeereliever ?
                        (
                          <Route path="/employeeReliever" element={<EmployeeReliever user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmploymentStatus ?
                        (
                          <Route path="/employmentStatus" element={<EmployementStatus user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeSchedule ?
                        (
                          <Route path="/employeeSchedule" element={<EmployeeSchedule user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOnBoardingPersonnel ?
                        (
                          <Route path="/onBoardingPersonnel" element={<OnBoardingPersonnel user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOnBoarding ?
                        (
                          <Route path="/onBoarding" element={<OnBoarding user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOutBoarding ?
                        (
                          <Route path="/outBoarding" element={<OutBoarding user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeTransaction ?
                        (
                          <Route path="/employeeTransaction" element={<EmployeeTransactionPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasCrewList ?
                        (
                          <Route path="/crewList" element={<CrewList user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeRequest ?
                        (
                          <Route path="/employeeRequest" element={<EmployeeRequest user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeTypeTagging ?
                        (
                          <Route path="/employeeTypeTagging" element={<EmployeeTypeTagging user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasUploadingSchedule ?
                        (
                          <Route path="/uploadingSchedule" element={<UploadingSchedulePage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMedicalClearance ?
                        (
                          <Route path="/medicalClearance" element={<MedicalClearancePage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasTrainingAndSeminarProgram ?
                        (
                          <Route path="/trainingAndSeminarProgram" element={<TrainingAndSeminarProgram user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasKpiPerformanceAppraisal ?
                        (
                          <Route path="/kpiPerformanceAppraisal" element={<KpiPerformanceAppraisal user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasTimeEntries ?
                        (
                          <Route path="/timeKeeping" element={<TimeKeeping user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasTamperedApproval ?
                        (

                          <Route path="/tamperedApproval" element={<TamperedApproval user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasShiftSchedule ?
                        (
                          <Route path="/shiftSchedule" element={<ShiftSchedule user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasUploadTimeEntriesFile ?
                        (
                          <Route path="/uploadTimeEntriesFile" element={<UploadTimeEntriesFile user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasUploadDaysEntries ?
                        (
                          <Route path="/uploadDaysEntries" element={<UploadDaysEntriesPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasUploadCvtLogs ?
                        (
                          <Route path="/uploadCvtLogs" element={<UploadCvtLogsPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasUploadTimeEntriesERE ?
                        (
                          <Route path="/uploadTimeEntriesERE" element={<UploadTimeEntriesERE user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasProcessPartialSalary ?
                        (
                          <Route path="/processPartialSalary" element={<ProcessPartialSalary user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPartialSalary ?
                        (
                          <Route path="/partialSalary" element={<PartialSalary user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasProcessPayroll ?
                        (
                          <Route path="/payroll" element={<Payroll user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPartialSalaryBatch ?
                        (
                          <Route path="/partialSalaryBatch" element={<PartialSalaryBatch user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.has13thMonth ?
                        (
                          <Route path="/thirteenthMonth" element={<ThirteenthMonth user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasFinalPay ?
                        (
                          <Route path="/finalPay" element={<FinalPay user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSubcon ?
                        (
                          <Route path="/subcon" element={<Subcon user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasAgency ?
                        (
                          <Route path="/agency" element={<Agency user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPayrollPeriod ?
                        (
                          <Route path="/payrollPeriod" element={<PayrollPeriod user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPayType ?
                        (
                          <Route path="/payType" element={<PayType user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasHoliday ?
                        (
                          <Route path="/holiday" element={<Holiday user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasHolidayType ?
                        (
                          <Route path="/holidayType" element={<HolidayType user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasLeaveType ?
                        (
                          <Route path="/leaveTypes" element={<LeaveTypes user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDepartment ?
                        (
                          <Route path="/department" element={<DepartmentPage user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSection ?
                        (
                          <Route path="/section" element={<Section user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasClassification ?
                        (
                          <Route path="/classification" element={<Classification user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasHRCalendar ?
                        (
                          <Route path="/hrCalendar" element={<HRCalendarPage user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasClient ?
                        (
                          <Route path="/client" element={<Client user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasCompany ?
                        (
                          <Route path="/company" element={<Company user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPosition ?
                        (
                          <Route path="/position" element={<PositionPage user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasJobTitle ?
                        (
                          <Route path="/jobTitle" element={<JobTitle user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeGroup1 ?
                        (
                          <Route path="/employeeGroup1" element={<EmployeeGroup1 user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeGroup2 ?
                        (
                          <Route path="/employeeGroup2" element={<EmployeeGroup2 user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeStatus ?
                        (
                          <Route path="/employeeStatus" element={<EmployeeStatus user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasLocation ?
                        (
                          <Route path="/location" element={<Location user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasTimeKeeper ?
                        (
                          <Route path="/timeKeeper" element={<TimeKeeper user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPlantilya ?
                        (
                          <Route path="/plantilya" element={<Plantilya user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasCostCenter ?
                        (
                          <Route path="/costCenter" element={<CostCenter user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPayrollJournalAccount ?
                        (
                          <Route path="/payrollJournalAccount" element={<PayrollJournalAccount user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOnBoardingRequirements ?
                        (
                          <Route path="/onBoardingRequirements" element={<Requirements user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOutBoardingRequirements ?
                        (
                          <Route path="/outBoardingRequirements" element={<OutBoardingRequirements user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMRF ?
                        (
                          <Route path="/mrf" element={<MRF user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasVessel ?
                        (
                          <Route path="/vessel" element={<Vessel user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasKpiLegend ?
                        (
                          <Route path="/kpiLegend" element={<KpiLegend user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDestination ?
                        (
                          <Route path="/destination" element={<Destination user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasVesselType ?
                        (
                          <Route path="/vesselType" element={<VesselType user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeType ?
                        (
                          // <Route path="/employeeType" element={<EmployeeType user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                          <Route path="/employeeType" element={<EmployeeTypePage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDivision ?
                        (
                          <Route path="/division" element={<Division user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />)
                        :
                        (<></>)
                      }
                      {userAccess?.hasVesselStatus ?
                        (
                          <Route path="/vesselStatus" element={<VesselStatus user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />)
                        :
                        (<></>)
                      }
                      {userAccess?.hasDistantWater ?
                        (
                          <Route path="/distantWater" element={<DistantWater user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasAreaOfOperation ?
                        (
                          <Route path="/areaOfOperation" element={<AreaOfOperation user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSubArea ?
                        (
                          <Route path="/subArea" element={<SubArea user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasVesselClass ?
                        (
                          <Route path="/vesselClass" element={<VesselClass user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOperationGroup ?
                        (
                          <Route path="/operationGroup" element={<OperationGroup user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasVesselFunction ?
                        (
                          <Route path="/vesselFunction" element={<VesselFunction user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMemoType ?
                        (
                          <Route path="/memoType" element={<MemoType user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasLoansAccess ?
                        (
                          <Route path="/loansAccess" element={<LoansAccess user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMRFAccess ?
                        (
                          <Route path="/mrfAccess" element={<MRFAccess user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPartialSalarySchedule ?
                        (
                          <Route path="/partialSalarySchedule" element={<PartialSalarySchedule user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasClinicRequirements ?
                        (
                          <Route path="/clinicRequirements" element={<ClinicRequirementsPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSalaryAdvanceDeductionBracket ?
                        (
                          <Route path="/salaryAdvanceDeductionBracket" element={<SalaryAdvanceDeductionBracketPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPayrollReasonCode ?
                        (
                          <Route path="/payrollReasonCode" element={<PayrollReasonCodePage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMaintenanceSalaryCombinationCode ?
                        (
                          <Route path="/maintenanceSalaryCombinationCode" element={<MaintenanceSalaryCombinationCodePage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeRequestAccess ?
                        (
                          <Route path="/employeeRequestAccess" element={<EmployeeRequestAccess user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeTransactionAccess ?
                        (
                          <Route path="/employeeTransactionAccess" element={<EmployeeTransactionAccessPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMedicalClearanceAccess ?
                        (
                          <Route path="/medicalClearanceAccess" element={<MedicalClearanceAccessPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSalaryAdvanceAccess ?
                        (
                          <Route path="/salaryAdvanceAccess" element={<SalaryAdvanceAccessPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasTransactionAccess ?
                        (
                          <Route path="/transactionAccess" element={<TransactionAccessPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasVessel201 ?
                        (
                          <Route path="/vessel201" element={<Vessel201 user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeMonthlySalary ?
                        (
                          <Route path="/employeeMonthlySalary" element={<EmployeeMonthlySalary user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeDailySalary ?
                        (
                          <Route path="/employeeDailySalary" element={<EmployeeDailySalary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasQuotaBasedSalary ?
                        // { true ? 
                        (
                          <Route path="/quotaBasedSalary" element={<QuotaBasedSalary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPositionDesignationSalary && (
                        <Route
                          path="/positionDesignationSalary"
                          element={
                            <PositionDesignationSalary
                              user={user}
                              isHideSideMenu={isHideSideMenu}
                            />
                          }
                        />
                      )}
                      {userAccess?.hasMaintenanceSalaryCombination ?
                        (
                          <Route path="/maintenanceSalaryCombination" element={<MaintenanceSalaryCombinationV2Page user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasEmployeeBankAccount ?
                        (
                          <Route path="/employeeBankAccount" element={<EmployeeBankAccount user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasBIRTax ?
                        (
                          <Route path="/tax" element={<Tax user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPagibig ?
                        (
                          <Route path="/pagibig" element={<Pagibig user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSSS ?
                        (
                          <Route path="/sss" element={<SSS user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPhilhealth ?
                        (
                          <Route path="/philhealth" element={<Philhealth user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDTR ?
                        (
                          <Route path="/dtr" element={<DTRAdminView user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDTRBiometrics ?
                        (
                          <Route path="/dtrBiometrics" element={<DTREmployeeView user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMobileDTRApproval ?
                        (
                          <Route path="/mobileDTRApproval" element={<MobileDTRApproval user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDTRWithOTViewing ?
                        (
                          <Route path="/dtrWithOTViewing" element={<DTRWithOTViewingPage user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasApproverHierarchy ?
                        (
                          <Route path="/approverHierarchy" element={<ApproverHierarchy user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasApproverheirarchyperlocation && FEATURES.APPROVER_PER_LOCATION?
                        (
                          <Route path="/approverHierarchyPerLocation" element={<ApproverHierarchyPerLocation isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasApproverMaintenance ?
                        (
                          <Route path="/approverMaintenance" element={<ApproverMaintenancePage isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasRequestApproval ?
                        (
                          <Route path="/requestApproval" element={<RequestApproval user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasRequestApprovalTimeKeeper ?
                        (
                          <Route path="/requestApprovalTimeKeeper" element={<RequestApprovalTimeKeeper user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMassapproval ?
                        (
                          <Route path="/massApproval" element={<MassApproval user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDTRCorrectionWorkers ?
                        (
                          <Route path="/dtrCorrectionWorkers" element={<DTRCorrectionWorkers user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {/* {userAccess?.hasLeaveEncashment ?
                        (
                          <Route path="/leaveEncashment" element={
                            isDevMode === true ? (
                              <LeaveEncashmentPage
                                user={user}
                                userAccess={userAccess}
                                isHideSideMenu={isHideSideMenu}
                              />
                            ) : (
                              <Navigate to="/inMaintenance" replace />
                            )
                          } />
                        )
                        :
                        (<></>)
                      } */}
                      {userAccess?.hasLeaveEncashment ?
                        (
                          <Route path="/leaveEncashment" element={<LeaveEncashmentPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasLeaveIncentive ?
                        (
                          <Route path="/leaveIncentive" element={
                            isDevMode === true ? (
                              <LeaveIncentivePage
                                user={user}
                                userAccess={userAccess}
                                isHideSideMenu={isHideSideMenu}
                              />
                            ) : (
                              <Navigate to="/inMaintenance" replace />
                            )
                          } />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOvertime ?
                        (
                          <Route path="/overtime" element={<Overtime user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDTRCorrection ?
                        (
                          <Route path="/dtrCorrection" element={<DTRCorrection user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasLeave ?
                        (
                          <Route path="/leave" element={<Leave user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasChangeOfSchedule ?
                        (
                          <Route path="/changeOfSchedule" element={<ChangeOfSchedule user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOffsetCredits ?
                        (
                          <Route path="/offsetCredits" element={<OffsetCredits user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOffsetRequest ?
                        (
                          <Route path="/offsetRequest" element={<OffsetRequest user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSalaryAdvanceRequest ?
                        (
                          <Route path="/salaryAdvanceRequest" element={<SalaryAdvanceRequest user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasLoanTransaction ?
                        (
                          <Route path="/loanTransaction" element={<LoanTransactionPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSSSLoan ?
                        (
                          <Route path="/sssLoan" element={<SSSLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSSSEmergencyLoan ?
                        (
                          <Route path="/sssEmergencyLoan" element={<SSSEmergencyLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSSSCalamityLoan ?
                        (
                          <Route path="/sssCalamityLoan" element={<SSSCalamityLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPagibigLoan ?
                        (
                          <Route path="/pagibigLoan" element={<PagibigLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPagibigLoan ?
                        (
                          <Route path="/pagibigLoan" element={<PagibigLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPagibigCalamityLoan ?
                        (
                          <Route path="/pagibigCalamityLoan" element={<PagibigCalamityLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasCashAdvance && FEATURES.ALOW_CASH_ADVANCE_MODULE ?
                        (
                          <Route path="/cashAdvance" element={<CashAdvance user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSalaryAdvance && FEATURES.ALLOW_SALARY_ADVANCE_MODULE ?
                        (
                          <Route path="/salaryAdvance" element={<SalaryAdvance user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasLoans ?
                        (
                          <Route path="/loans" element={<Loans user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasDeductions ?
                        (
                          <Route path="/deductions" element={<Deductions user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasBenefits ?
                        (
                          <Route path="/benefits" element={<Benefits user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPerDayTracker ? (
                        <Route path="/perDayTracker" element={<PerDayTracker isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOvertimeSummaryReport ? (
                        <Route path="/overtimeSummaryReport" element={<OvertimeSummaryReport isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }
                      {userAccess?.hasTrackerReport ? (
                        <Route path="/trackerReport" element={<TrackerReport isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPayslip ? (
                        <Route path="/payslip" element={<Payslip isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }
                      {userAccess?.hasPayrollRegister ? (
                        <Route path="/payrollRegister" element={<PayrollRegister user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasResigned ? (
                        <Route path="/resigned" element={<Resigned user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasActiveEmployees ? (
                        <Route path="/activeEmployees" element={<ActiveEmployees user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasYearofService ? (
                        <Route path="/yearOfService" element={<YearOfService user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasSSSSummary ? (
                        <Route path="/sss-report" element={<SSSReport user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPagibigSummary ? (
                        <Route path="/pagibig-report" element={<PagibigReport user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPhilhealthSummary ? (
                        <Route path="/philhealth-report" element={<PhilhealthReport user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasSSSLoanReport ? (
                        <Route path="/sssLoan-report" element={<SSSLoanReport isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPagibigLoanReport ? (
                        <Route path="/pagibigLoan-report" element={<PagibigLoanReport isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.has201Report ? (
                        <Route path="/201report" element={<Report201 isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasAttendanceReport ? (
                        <Route path="/attendanceReport" element={<AttendanceReport user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBankTransmittalBPI ? (
                        <Route path="/bankTransmittalBPI" element={<BankTransmittalBPI isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBankTransmittalBDO ? (
                        <Route path="/bankTransmittalBDO" element={<BankTransmittalBDO isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBankTransmittalChinaBankSavings ? (
                        <Route path="/bankTransmittalChinaBankSavings" element={<BankTransmittalChinaBank isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBankTransmittalHSBC ? (
                        <Route path="/bankTransmittalHSBC" element={<BankTransmittalHSBC isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBankTransmittalSecurityBank ? (
                        <Route path="/bankTransmittalSecurityBank" element={<BankTransmittalSecurityBank isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasSummaryOfTardiness ? (
                        <Route path="/summaryOfTardiness" element={<SummaryOfTardiness user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasAbsencesMemo ? (
                        <Route path="/absencesMemo" element={<AbsencesMemo user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasAbsencesReport ? (
                        <Route path="/absencesReport" element={<AbsencesReport user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasActionHistoryReport ? (
                        <Route path="/actionHistoryReport" element={<ActionHistoryReport user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasAllowanceSummary ? (
                        <Route path="/allowanceSummary" element={<AllowanceSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasAuditTrailReportEmployeeSetup ? (
                        <Route path="/auditTrailReportEmployeeSetup" element={<AuditTrailReportEmployeeSetup user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBasicPayAdjustmentReport ? (
                        <Route path="/basicPayAdjustmentReport" element={<BasicPayAdjustmentReport user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBundyClockUsage ? (
                        <Route path="/bundyClockUsage" element={<BundyClockUsage isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasCertificateOfEmployment ? (
                        <Route path="/certificateOfEmployment" element={<CertificateOfEmployment user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasCertificateOfPagibig ? (
                        <Route path="/certificateOfPagibig" element={<CertificateOfPagibig user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasCertificateOfPhilhealth ? (
                        <Route path="/certificateOfPhilhealth" element={<CertificateOfPhilhealth user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }

                      {userAccess?.hasCertificateOfSSS ? (
                        <Route path="/certificateOfSSS" element={<CertificateOfSSS user={user} isHideSideMenu={isHideSideMenu} />} />
                      )
                        :
                        (<></>)
                      }
                      {userAccess?.hasCommissionsSummary ?
                        (
                          <Route path="/commissionsSummary" element={<CommissionsSummary isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasCostCenterReport ?
                        (
                          <Route path="/costCenterReport" element={<CostCenterReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasDeductionsPerMonth ?
                        (
                          <Route path="/deductionsPerMonth" element={<DeductionsPerMonth user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasDTRReport ?
                        (
                          <Route path="/dtrReport" element={<DTRReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEarningsPerMonth ?
                        (
                          <Route path="/earningsPerMonth" element={<EarningsPerMonth user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmployeeLeaveGroup ?
                        (
                          <Route path="/employeeLeaveGroup" element={<EmployeeLeaveGroup user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmployeeOvertimeGroup ?
                        (
                          <Route path="/employeeOvertimeGroup" element={<EmployeeOvertimeGroup user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmployeeExpenseGroup ?
                        (
                          <Route path="/employeeExpenseGroup" element={<EmployeeExpenseGroup isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmployeeLeaveHistory ?
                        (
                          <Route path="/employeeLeaveHistory" element={<EmployeeLeaveHistory user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmployeeListingByHiringDate ?
                        (
                          <Route path="/employeeListingByHiringDate" element={<EmployeeListingByHiringDate user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmployeeRegister ?
                        (
                          <Route path="/employeeRegister" element={<EmployeeRegister user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasExpenseReport ?
                        (
                          <Route path="/expenseReport" element={<ExpenseReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasGovernmentEmployeeInventory ?
                        (
                          <Route path="/governmentEmployeeInventory" element={<GovernmentEmployeeInventory isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasHeadcountReport ?
                        (
                          <Route path="/headcountReport" element={<HeadcountReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasHolidayPremiumSummary ?
                        (
                          <Route path="/holidayPremiumSummary" element={<HolidayPremiumSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasLeaveLedgerReport ?
                        (
                          <Route path="/leaveLedgerReport" element={<LeaveLedgerReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasLeaveSummaryReport ?
                        (
                          <Route path="/leaveSummaryReport" element={<LeaveSummaryReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasLoanHistory ?
                        (
                          <Route path="/loanHistory" element={<LoanHistory user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasLoanPaymentsSummary ?
                        (
                          <Route path="/loanPaymentsSummary" element={<LoanPaymentsSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasLoansMonthlyAmortizationSummary ?
                        (
                          <Route path="/loansMonthlyAmmortizationSummary" element={<LoansMonthlyAmmortizationSummary isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasLoansPenaltyHistory ?
                        (
                          <Route path="/loansPenaltyHistory" element={<LoansPenaltyHistory isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasNightDifferentialSummary ?
                        (
                          <Route path="/nightDifferentialSummary" element={<NightDifferentialSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasNonTaxableAllowancesReport ?
                        (
                          <Route path="/nonTaxableAllowancesReport" element={<NonTaxableAllowancesReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasOtherEarningsReport ?
                        (
                          <Route path="/otherEarningsReport" element={<OtherEarningsReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasOtherDeductionsSummary ?
                        (
                          <Route path="/otherDeductionsSummary" element={<OtherDeductionsSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasOutstandingLoans ?
                        (
                          <Route path="/outstandingLoans" element={<OutstandingLoans isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPayrollCashRegister ?
                        (
                          <Route path="/payrollCashRegister" element={<PayrollCashRegister user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPayrollCheckRegister ?
                        (
                          <Route path="/payrollCheckRegister" element={<PayrollCheckRegister user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPayrollDebitMemo ?
                        (
                          <Route path="/payrollDebitMemo" element={<PayrollDebitMemo isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPayrollJournalByCostCenter ?
                        (
                          <Route path="/payrollJournalByCostCenter" element={<PayrollJournalByCostCenter user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPayrollJournalByDepartment ?
                        (
                          <Route path="/payrollJournalByDepartment" element={<PayrollJournalByDepartment user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPayrollJournalBySummary ?
                        (
                          <Route path="/payrollJournalBySummary" element={<PayrollJournalBySummary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasPayrollPerPaymentMethod ?
                        (
                          <Route path="/payrollPerPaymentMethod" element={<PayrollPerPaymentMethod isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasSelectLogs ?
                        (
                          <Route path="/selectLogs" element={<SelectLogs user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasSummaryReportByMonthAndDepartment ?
                        (
                          <Route path="/summaryReportByMonthAndDepartment" element={<SummaryReportByMonthAndDepartment isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasTardinessMemo ?
                        (
                          <Route path="/tardinessMemo" element={<TardinessMemo user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasTimeKeepingHistoryDetailedReport ?
                        (
                          <Route path="/timeKeepingHistoryDetailedReport" element={<TimeKeepingHistoryDetailedReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasTimeKeepingHoursWorkedReport ?
                        (
                          <Route path="/timeKeepingHoursWorkedReport" element={<TimeKeepingHoursWorkedReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasTimeKeepingHoursWorkedSummary ?
                        (
                          <Route path="/timeKeepingHoursWorkedSummary" element={<TimeKeepingHoursWorkedSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasTimesheetStatusReport ?
                        (
                          <Route path="/timesheetStatusReport" element={<TimesheetStatusReport isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasYTDDeductionSummary ?
                        (
                          <Route path="/ytdDeductionSummary" element={<YTDDeductionSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasYTDEarningsSummary ?
                        (
                          <Route path="/ytdEarningsSummary" element={<YTDEarningsSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasYTDPayrollRegister ?
                        (
                          <Route path="/ytdPayrollRegister" element={<YTDPayrollRegister user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBIR2316 ?
                        (
                          <Route path="/BIR2316" element={<BIR2316 isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBIR1601C ?
                        (
                          <Route path="/BIR1601C" element={<BIR1601C isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBIR0619E ?
                        (
                          <Route path="/BIR0619E" element={<BIR0619E isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBIR0619F ?
                        (
                          <Route path="/BIR0619F" element={<BIR0619F isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBIR0619F ?
                        (
                          <Route path="/reportR1A" element={<ReportR1A isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasReportR3 ?
                        (
                          <Route path="/reportR3" element={<ReportR3 isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasReportR5 ?
                        (
                          <Route path="/reportR5" element={<ReportR5 isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasReportML1 ?
                        (
                          <Route path="/reportML1" element={<ReportML1 isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmployeeContributionHistory ?
                        (
                          <Route path="/employeeContributionHistory" element={<EmployeeContributionHistory isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasSalaryLoanDeductionReport ?
                        (
                          <Route path="/salaryLoanDeductionReport" element={<SalaryLoanDeductionReport isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasCalamityLoanDeductionSummary ?
                        (
                          <Route path="/calamityLoanDeductionSummary" element={<ReportSSSCalamityLoan isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasReportMCRFModule ?
                        (
                          <Route path="/reportMCRFModule" element={<ReportMCRF isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasReportSTL ?
                        (
                          <Route path="/reportSTL" element={<ReportSTL isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasReportHousingLoan ?
                        (
                          <Route path="/reportHousingLoan" element={<ReportHousingLoan isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasReportRF1 ?
                        (
                          <Route path="/reportRF1" element={<ReportRF1 isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasReportER2 ?
                        (
                          <Route path="/reportER2" element={<ReportER2 isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasEmployeeContributionLedger ?
                        (
                          <Route path="/employeeContributionLedger" element={<EmployeeContributionLedger isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasSeparatedEmployeeReport ?
                        (
                          <Route path="/separatedEmployeeReport" element={<SeparatedEmployeeReport isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasAlphaList ?
                        (
                          <Route path="/alphalist" element={<Alphalist user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasLoanReport ?
                        (
                          <Route path="/loanReport" element={<LoanReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasBankTransmittalReport ?
                        (
                          <Route path="/bankTransmittalReport" element={<BankTransmittalReport user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      {userAccess?.hasUser ?
                        (
                          <Route path="/users" element={<Users user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasSettings ?
                        (
                          <Route path="/settings" element={<Settings isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasCalendar ?
                        (
                          <Route path="/calendar" element={<Calendar user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {userAccess?.hasMaintenance ?
                        (
                          <>
                            <Route path="/ecola" element={<Ecola isHideSideMenu={isHideSideMenu} />} />
                            <Route path="/sssAdjustmentDate" element={<SSSAdjustmentDate isHideSideMenu={isHideSideMenu} />} />
                          </>
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/dtrRulesConfiguration" element={<DTRRulesConfiguration user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/otFormulas" element={<OTFormulas user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/monthlyWorkingDaysFormulas" element={<MonthlyWorkingDaysFormulas user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/nightDifferential" element={<NightDifferential user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/govPremiumFormulas" element={<GovPremiumFormulas user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/clientIdentity" element={<ClientIdentity user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/gracePeriod" element={<GracePeriodFormulas user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/payrollRateConfig" element={<PayrollRateConfig user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/excelUploadHelper" element={<ExcelUploadHelper user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/leaveTypesDev" element={<LeaveTypePageDev user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/devTest" element={<DevTest user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }
                      {DEV_MODE ?
                        (
                          <Route path="/devHobby" element={<DevHobby user={user} isHideSideMenu={isHideSideMenu} />} />
                        )
                        :
                        (<></>)
                      }

                      <Route
                        path="*"
                        element={
                          <AccessRequired userAccess={userAccess} />
                        }
                      />

                      <Route
                        path="/inMaintenance"
                        element={<Maintenance userAccess={userAccess} />}
                      />

                    </Routes>
                  </div>
                </>
              )}
            </>
            :
            <>
              <SubscriptionExpiredPage />
            </>
          }
        </div>
      </RefetchProvider>
    </>
  );
}

export default App;